import type {
  COLORS_GRAY_01,
  COLORS_GRAY_10,
  COLORS_GRAY_11,
  COLORS_GRAY_12,
  COLORS_GRAY_13,
  COLORS_GRAY_02,
  COLORS_GRAY_03,
  COLORS_GRAY_04,
  COLORS_GRAY_05,
  COLORS_GRAY_06,
  COLORS_GRAY_07,
  COLORS_GRAY_08,
  COLORS_GRAY_09,
  COLORS_BLUE_01,
  COLORS_BLUE_02,
  COLORS_BLUE_03,
  COLORS_BLUE_04,
  COLORS_BLUE_05,
  COLORS_BLUE_06,
  COLORS_BLUE_07,
  COLORS_BLUE_08,
  COLORS_BLUE_09,
  COLORS_BLUE_10,
  COLORS_ORANGE_01,
  COLORS_ORANGE_02,
  COLORS_ORANGE_03,
  COLORS_ORANGE_04,
  COLORS_ORANGE_05,
  COLORS_ORANGE_06,
  COLORS_ORANGE_07,
  COLORS_ORANGE_08,
  COLORS_ORANGE_09,
  COLORS_ORANGE_10,
  COLORS_GREEN_01,
  COLORS_GREEN_02,
  COLORS_GREEN_03,
  COLORS_GREEN_04,
  COLORS_GREEN_05,
  COLORS_GREEN_06,
  COLORS_GREEN_07,
  COLORS_GREEN_08,
  COLORS_GREEN_09,
  COLORS_GREEN_10,
} from '@app/constants';

export namespace NColors {
  export type AntdPalleteColor =
    | GrayAntdColor
    | BlueAntdColor
    | OrangeAntdColor
    | GreenAntdColor;

  export type GrayAntdColor =
    | typeof COLORS_GRAY_01
    | typeof COLORS_GRAY_02
    | typeof COLORS_GRAY_03
    | typeof COLORS_GRAY_04
    | typeof COLORS_GRAY_05
    | typeof COLORS_GRAY_06
    | typeof COLORS_GRAY_07
    | typeof COLORS_GRAY_08
    | typeof COLORS_GRAY_09
    | typeof COLORS_GRAY_10
    | typeof COLORS_GRAY_11
    | typeof COLORS_GRAY_12
    | typeof COLORS_GRAY_13;

  export type BlueAntdColor =
    | typeof COLORS_BLUE_01
    | typeof COLORS_BLUE_02
    | typeof COLORS_BLUE_03
    | typeof COLORS_BLUE_04
    | typeof COLORS_BLUE_05
    | typeof COLORS_BLUE_06
    | typeof COLORS_BLUE_07
    | typeof COLORS_BLUE_08
    | typeof COLORS_BLUE_09
    | typeof COLORS_BLUE_10;

  export type OrangeAntdColor =
    | typeof COLORS_ORANGE_01
    | typeof COLORS_ORANGE_02
    | typeof COLORS_ORANGE_03
    | typeof COLORS_ORANGE_04
    | typeof COLORS_ORANGE_05
    | typeof COLORS_ORANGE_06
    | typeof COLORS_ORANGE_07
    | typeof COLORS_ORANGE_08
    | typeof COLORS_ORANGE_09
    | typeof COLORS_ORANGE_10;

  export type GreenAntdColor =
    | typeof COLORS_GREEN_01
    | typeof COLORS_GREEN_02
    | typeof COLORS_GREEN_03
    | typeof COLORS_GREEN_04
    | typeof COLORS_GREEN_05
    | typeof COLORS_GREEN_06
    | typeof COLORS_GREEN_07
    | typeof COLORS_GREEN_08
    | typeof COLORS_GREEN_09
    | typeof COLORS_GREEN_10;
}

export interface ColorFactory {
  metaColor: {
    a?: number;
    b?: number;
    format?: string;
    g?: number;
    gradientType?: string;
    isValid?: boolean;
    originalInput?: string;
    r?: number;
    roundA?: number;
    toHexString: () => string;
  };
}
